/**
 * 泉港公众号2.1的api请求
 */
import request from "@/libs/request";
/**登录 */
//登录模块 登录
export const loginApi = (data = {}) => {
    return request({
        url: "/userLoginWithPwd",
        method: "post",
        data: data,
    });
};
//登录模块 登出
export const logoutApi = (data = {}) => {
    return request({
        url: "/logout",
        method: "post",
        data: data,
    });
};
//登录模块 验证码登录
export const loginWithCodeApi = (data = {}) => {
    return request({
        url: "/login",
        method: "post",
        data: data,
    });
};
//登录模块 发送短信
export const sendSmsApi = (data = {}) => {
    return request({
        url: "/getWxSmsCode",
        method: "post",
        data: data,
    });
};

// 登录模块 获取公众号openId
export const getOpenId = (data = {}) => {
    return request({
        url: "/getOpenId",
        method: "post",
        data: data,
    });
};

/**首页数据 */

export const gethomePageData = (data = {}) => {
    return request({
        url: "/user/homePage",
        method: "post",
        data: data,
    });
};

/**个人中心 */
//个人中心模块 获取用户信息
export const getUserInfoApi = (data = {}) => {
    return request({
        url: "/user/baseInfo",
        method: "post",
        data: data,
    });
};

//个人中心模块 获取个人中心用户信息
export const getCenterUserInfoApi = (data = {}) => {
    return request({
        url: "/user/centerInfo",
        method: "post",
        data: data,
    });
};

//个人中心模块 修改密码
export const updatePwdApi = (data = {}) => {
    return request({
        url: "/user/updateUserLoginPwd",
        method: "post",
        data: data,
    });
};

//个人中心模块 校验验证码
export const checkSmsCode = (data = {}) => {
    return request({
        url: "/checkSmsCode",
        method: "post",
        data: data,
    });
};

//个人中心模块 更换绑定手机
export const updatePhoneApi = (data = {}) => {
    return request({
        url: "/user/phoneNoUpdate",
        method: "post",
        data: data,
    });
};
//个人中心模块 获取用户余额余额
export const walletBalance = (data = {}) => {
    return request({
        url: "/user/walletBalance",
        method: "post",
        data: data,
    });
};
// 个人中心模块 获取用户某月账单总金额
export const billMoney = (data = {}) => {
    return request({
        url: "/user/billMoney",
        method: "post",
        data: data,
    });
};
// 个人中心模块 获取用户某月账单金额明细
export const billDetail = (data = {}) => {
    return request({
        url: "/user/billDetail",
        method: "post",
        data: data,
    });
};
//个人中心模块 停车场编号 和 需要支付金额 获取最优优惠券
export const bestSuitCoupon = (data = {}) => {
    return request({
        url: "/user/bestSuitCoupon",
        method: "post",
        data: data,
    });
};

// 个人中心模块 获取优惠券
export const couponDetail = (data = {}) => {
    return request({
        url: "/user/couponDetail",
        method: "post",
        data: data,
    });
};
// 新增实名认证
export const createIdCardApi = (data = {}) => {
    return request({
        url: "/user/certificate",
        method: "post",
        data: data,
    });
};

/**车辆模块 */
//车辆模块 用户绑定车辆列表
export const getBindListApi = (data = {}) => {
    return request({
        url: "/userCar/list",
        method: "post",
        data: data,
    });
};
//车辆模块 用户车辆编辑
export const editCarApi = (data = {}) => {
    return request({
        url: "/userCar/setUp",
        method: "post",
        data: data,
    });
};
//车辆模块 删除车辆
export const deleteCarApi = (data = {}) => {
    return request({
        url: "/userCar/unbind",
        method: "post",
        data: data,
    });
};
//车辆模块 添加车辆
export const addCarApi = (data = {}) => {
    return request({
        url: "/userCar/add",
        method: "post",
        data: data,
    });
};

// 车辆模块 车辆认证
export const carAuthAdd = (data = {}) => {
    return request({
        url: "/userCar/certification",
        method: "post",
        data: data,
    });
};

/**投诉建议 */
//订单申诉
export const orderAppeal = (data = {}) => {
    return request({
        url: "/feedbackOpinion/orderAppeal",
        method: "post",
        data: data,
    });
};

//订单申诉分页列表
export const queryOrderAppealList = (data = {}) => {
    return request({
        url: "/feedbackOpinion/queryOrderAppealList",
        method: "post",
        data: data,
    });
};

//投诉建议
export const complaintAdvise = (data = {}) => {
    return request({
        url: "/feedbackOpinion/complaintAdvise",
        method: "post",
        data: data,
    });
};

//投诉建议分页列表
export const queryComplaintAdviseList = (data = {}) => {
    return request({
        url: "/feedbackOpinion/queryComplaintAdviseList",
        method: "post",
        data: data,
    });
};

//反馈意见消息推送
export const msgPush = (data = {}) => {
    return request({
        url: "/feedbackOpinion/msgPush",
        method: "post",
        data: data,
    });
};

// 反馈意见消息详情
export const msgDetail = (data = {}) => {
    return request({
        url: "/feedbackOpinion/msgDetail",
        method: "post",
        data: data,
    });
};

//申诉上传文件
export const uploadComplaint = (file) => {
    let param = new FormData();
    param.append("file", file);
    return request({
        url: "/file/folder/upload?folder=complaint",
        method: "post",
        data: param,
    });
};

// 车辆认证上传
export const uploadCarAuth = (file) => {
    let param = new FormData();
    param.append("file", file);
    return request({
        url: "/file/folder/upload?folder=carAuth",
        method: "post",
        data: param,
    });
};

// 身份证上传文件
export const uploadIdentityCard = (file) => {
    let param = new FormData();
    param.append("file", file);
    return request({
        url: "/file/folder/upload?folder=identityCard",
        method: "post",
        data: param,
    });
};

// 停车记录
export const getListParkRecordApi = (data = {}) => {
    return request({
        url: "/recordList",
        method: "post",
        data: data,
    });
};

// 获取支付订单
export const payList = (data = {}) => {
    return request({
        url: "/billRecordList",
        method: "post",
        data: data,
    });
};

//获取车牌分页
export const carNumList = (data = {}) => {
    return request({
        url: "/userCar/list",
        method: "post",
        data: data,
    });
};

//获取车场
export const getParkDistribute = (data = {}) => {
    return request({
        url: "/park/getParkDistribute",
        method: "post",
        data: data,
    });
};
//获取推荐车场
export const getSearchRecommendList = (data = {}) => {
    return request({
        url: "/park/getSearchRecommendList",
        method: "post",
        data: data,
    });
};

//输入车牌查费
export const getParkFeeByPlateNum = (data = {}) => {
    return request({
        url: "/queryParkFee",
        method: "post",
        data: data,
    });
};

/**缴费模块 */
//缴费模块 车费查询
export const queryParkFee = (data = {}) => {
    return request({
        url: "/queryParkFee",
        method: "post",
        data: data,
    });
};
//缴费模块 让服务器有个缓存
export const queryParkingInfo = (data = {}) => {
    return request({
        url: "/queryParkingInfo",
        method: "post",
        data: data,
    });
};
//缴费模块  路内路内发起通用聚合支付订单提交（单笔）
export const commonOrderSubmit = (data = {}) => {
    return request({
        url: "/aggregatePay/commonOrderSubmit",
        method: "post",
        data: data,
    });
};
//缴费模块 批量支付（末缴费-欠费）
export const submitOneKeyPay = (data = {}) => {
    return request({
        url: "/aggregatePay/submitOneKeyPay",
        method: "post",
        data: data,
    });
};

//缴费模块 余额充值
export const submitWalletOrder = (data = {}) => {
    return request({
        url: "/aggregatePay/submitWalletOrder",
        method: "post",
        data: data,
    });
};
//缴费模块 统一下单
export const unifiedOrder = (data = {}) => {
    return request({
        url: "/aggregatePay/unifiedOrder",
        method: "post",
        data: data,
    });
};
//缴费模块 公众号原生下单
export const nativePayCommitOrder = (data = {}) => {
    return request({
        url: "/aggregatePay/nativePayCommitOrder",
        method: "post",
        data: data,
    });
};

//缴费模块 路外余额支付
export const openWalletPay = (data = {}) => {
    return request({
        url: "/aggregatePay/openWalletPay",
        method: "post",
        data: data,
    });
};
//缴费模块 路外获取支付结果
export const openPayResult = (data = {}) => {
    return request({
        url: "/aggregatePay/openPayResult",
        method: "post",
        data: data,
    });
};

/**开票模块 */
//开票模块 1、获取可开票停车场
export const listElectronicInvoicePark = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/listElectronicInvoicePark",
        method: "post",
        data: data,
    });
};
//开票模块 2、获取订单类型字典值
export const selectContentByOrderType = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/selectContentByOrderType",
        method: "post",
        data: data,
    });
};

//开票模块 3、获取发票代码（根据抬头）
export const selectCodeByTitle = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/selectCodeByTitle",
        method: "post",
        data: data,
    });
};
//开票模块 4、根据发票代码获取企业税号
export const selectTaxByCode = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/selectTaxByCode",
        method: "post",
        data: data,
    });
};

// 开票模块 5、获取可开票订单
export const selectAllOrderInvoice = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/selectAllOrderInvoice",
        method: "post",
        data: data,
    });
};
// 开票模块 6、开票
export const registerInvoice = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/registerInvoice",
        method: "post",
        data: data,
    });
};

// 开票模块 7、获取开票结果
export const resultInvoice = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/resultInvoice",
        method: "post",
        data: data,
    });
};

// 开票模块 8、获取开票记录列表
export const listElectronicInvoice = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/listElectronicInvoice",
        method: "post",
        data: data,
    });
};
// 开票模块 9、开票成功重新推送邮箱和手机
export const resendInvoiceMsg = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/resendInvoiceMsg",
        method: "post",
        data: data,
    });
};

// 开票模块 10、发票开票失败，重新推送开票
export const restartElectronicInvoice = (data = {}) => {
    return request({
        url: "/electronicInvoice/nuonuo/restartElectronicInvoice",
        method: "post",
        data: data,
    });
};

// 微信JSSDK 鉴权
export const getScanSign = (data = {}) => {
    return request({
        url: "/wxAuth/getScanSign",
        method: "post",
        data: data,
    });
};
